import * as React from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import HotelIcon from '@mui/icons-material/Hotel'
import ChevronRightSharpIcon from '@mui/icons-material/ChevronRightSharp';
import { useHistory } from "react-router";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { isInsurerAdmin , isInsurerCallCenter } from "../../services/insurance/common";
import { Roles } from '../../constants/insurance/constant';

export default function NestedList(props) {
  const history = useHistory();
  const [open, setOpen] = React.useState(true);


  const [lists] = React.useState([
    { id: 1, name: 'New Appointments', routeName: '/appointments' },
    { id: 2, name: 'Esales Queue', routeName: '/appointments/esalesqueue' },
  ]);

  const createAppointment = () => {
    history.push("/"+localStorage.getItem("roleName")+"/appointments/create");
    props.toggleDrawerFunction()
  }

  const showAppointment = () => {
    history.push("/"+localStorage.getItem("roleName")+"/appointments")
    props.toggleDrawerFunction()
  }

  const eSalesQueue = () => {
    history.push("/"+localStorage.getItem("roleName")+ "/appointments/esalesqueue")
    props.toggleDrawerFunction()
  }

  const handleClick = () => {
    setOpen(!open);
  };

  const isInsurerCallCenterRoleFeatures=()=>{
    let insurerCallCenter = false;
    let roleFeatures = JSON.parse(localStorage.getItem("user_details")).rolesFeatures;
    roleFeatures.roles.forEach(ele => {
      if(ele.roleId === Roles.insurercallCentre ) insurerCallCenter = true;
    });
    return insurerCallCenter;
  }

  return (
    <List
      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        props.providerDetails && props.providerDetails.entityName ?
          <ListSubheader component="div" className="p-0" id="nested-list-subheader" sx={{ padding: 0 }}>
            <div className='font-semibold bg-nested-menu-header leading-tight pt-4 pb-6 px-4'>
              <div>
                {props.providerDetails.entityName}
              </div>
            </div>
          </ListSubheader> : ''
      }
    >
      <ListItemButton onClick={handleClick}>
        <ListItemIcon sx={{ minWidth: '40px' }}>
          <HotelIcon />
        </ListItemIcon>
        <ListItemText primary="Appointments" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 4 }} onClick={showAppointment}>
            <ListItemIcon sx={{ minWidth: '30px' }}>
              <ChevronRightSharpIcon />
            </ListItemIcon>
            <ListItemText>All Appointments</ListItemText>
          </ListItemButton>
         {/* { isInsurerAdmin() &&  isInsurerCallCenter() && <ListItemButton sx={{ pl: 4 }} onClick={createAppointment}> */}
         { isInsurerCallCenterRoleFeatures() && <ListItemButton sx={{ pl: 4 }} onClick={createAppointment}>
            <ListItemIcon sx={{ minWidth: '30px' }}>
              <ChevronRightSharpIcon />
            </ListItemIcon>
            <ListItemText primary="Create Appointment" />
          </ListItemButton>
          }
          <ListItemButton sx={{ pl: 4 }} onClick={eSalesQueue}>
            <ListItemIcon sx={{ minWidth: '30px' }}>
              <ChevronRightSharpIcon />
            </ListItemIcon>
            <ListItemText primary="ESales Queue"/>
          </ListItemButton>
        </List>
      </Collapse>
    </List>
  );
}